import { render, staticRenderFns } from "./PerfilCadastro.vue?vue&type=template&id=93f63172&scoped=true&"
import script from "./PerfilCadastro.vue?vue&type=script&lang=js&"
export * from "./PerfilCadastro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93f63172",
  null
  
)

export default component.exports